<template>
  <div id="app">
    <div class="content">
      <JsonViewer/>
    </div>
  </div>
</template>

<script>
import JsonViewer from './components/JsonViewer.vue'

export default {
  name: 'app',
  components: {
    JsonViewer
  }
}

var _hmt = _hmt || [];
(function () {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?d509a6c67b04a5bb16e4a4bdbd512bae";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
</script>
